import { render, staticRenderFns } from "./userRoleView.vue?vue&type=template&id=76f03138&scoped=true&"
import script from "./userRoleView.vue?vue&type=script&lang=js&"
export * from "./userRoleView.vue?vue&type=script&lang=js&"
import style0 from "./userRoleView.vue?vue&type=style&index=0&id=76f03138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f03138",
  null
  
)

export default component.exports